/** Lemas de la portada: cambia en cada visita. */
const PHRASES = [
  "LA MEJOR COMUNIDAD",
  "AQUÍ SE FORJAN IDEAS",
  "CREADORES SIN LÍMITES",
  "TU TALLER DIGITAL",
  "IMAGINA. FORJA. COMPARTE.",
  "DONDE LAS IMÁGENES COBRAN VIDA",
];

export const pickCoverPhrase = () => PHRASES[Math.floor(Math.random() * PHRASES.length)];

export default PHRASES;
